import { z } from 'zod';
import { AwsAccountIdRegex } from './aws-patterns.constants';
import { AWS_ACCOUNT_ID_LENGTH } from './aws.constants';

export const AwsAccountIdSchema = z
  .string()
  .trim()
  .length(AWS_ACCOUNT_ID_LENGTH)
  .regex(AwsAccountIdRegex, {
    error: 'AWS account ID must be a 12-digit number',
  });
